module.exports = __webpack_public_path__ + "media/fotorama/fotorama@2x-e73a31de.png";